import React from 'react';
import PropTypes from 'prop-types';
import { StyledText } from './style';

const Text = ({ children, type, color, onClick, className, mb, mt, tag, htmlFor }) => {
  if (
    (typeof children !== 'number' && !children) ||
    (typeof children === 'object' && Object.keys(children) <= 0)
  ) {
    return <span>-</span>;
  }

  return (
    <StyledText
      className={`${
        type === 'h1.5'
          ? 'h1-5'
          : type === 'h2.5'
          ? 'h2-5'
          : type === 'h3.5'
          ? 'h3-5'
          : type
      } ${onClick ? 'link' : ''} ${className || ''}`}
      color={color}
      as={tag ?? (
        type === 'h1'
          ? 'h1'
          : type === 'h1.5' || type === 'h-modal'
          ? 'h2'
          : type === 'h2'
          ? 'h2'
          : type === 'h2.5'
          ? 'h3'
          : type === 'h3'
          ? 'h3'
          : type === 'h3.5'
          ? 'h4'
          : type === 'h5'
          ? 'h5'
          : 'div'
      )}
      onClick={onClick}
      mb={mb || 0}
      mt={mt || 0}
      htmlFor={htmlFor}
    >
      {children}
    </StyledText>
  );
};

Text.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf([
    'h1',
    'h-modal',
    'h1.5',
    'h2',
    'h2.5',
    'h3',
    'h3.5',
    'h5',
    'b1',
    'b2',
    'b3',
    'b4',
    'b5',
    'statistics-heading',
  ]).isRequired,
  color: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  mb: PropTypes.number,
  mt: PropTypes.number,
  tag: PropTypes.string,
  htmlFor: PropTypes.string,
};

export default Text;
